module.exports = __webpack_public_path__ + "static/media/a1.ddd0a34.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dili/a1.mp3
// module id = vb6z
// module chunks = 0